import React from 'react';
import { Box, Image } from '@chakra-ui/react';
import { CustomCardProps } from '../../../types/layout';

export default function CustomCard({ imageUrl, imageAlt, isImage, children, ...props }: CustomCardProps) {
    return (
        <Box borderWidth='1px' borderRadius='lg' overflow='hidden' boxShadow='0 2px 8px 0 rgba(0, 0, 0, 0.15)' {...props}>
           {isImage ?  <Image src={imageUrl!} alt={imageAlt!} /> : null}
            <Box p='6' paddingBottom={'4'}>
                {children}
            </Box>
    </Box>
    )
}
